import React, { useEffect, useState } from "react";

import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  TextField,
  Switch,
} from "@material-ui/core";
import FaceSelector from "./FaceSelector";
import _ from "lodash";
import CSATService from "../../services/csat";

export default (props) => {
  const [show, setShow] = useState(false);
  const [step, setStep] = useState(1);
  const [practiceRating, setPracticeRating] = useState(null);
  const [providerRating, setProviderRating] = useState(null);
  const [providerTextResp, setProviderTextResp] = useState("");
  const [practiceTextResp, setPracticeTextResp] = useState("");
  const [activePrompt, setActivePrompt] = useState("");
  const [checked, setChecked] = useState(false);

  const practicePrompt = `How satisfied are you with the care you've received at ${props.practice}?`;
  const providerPrompt = `How satisfied are you with the care you've received from ${props.provider}?`;

  const practiceBetterText = `What could ${props.practice} improve to have made your care better?`;
  const practiceEvenBetterText = `What is one thing ${props.practice} can improve that would have made your care even better?`;
  const providerBetterText = `What could ${props.provider} have done to have made your care better?`;
  const providerEvenBetterText = `What is one thing ${props.provider} could improve that would make your care even better?`;

  const openDiag = () => {
    setShow(true);
  };
  const closeDiag = () => {
    setShow(false);
    setStep(1);
    setChecked(false);
    setRating(null);
    setProviderRating(null);
    setPracticeRating(null);
    setProviderTextResp("");
    setPracticeTextResp("");
    props.onClose();
  };

  useEffect(() => {
    setShow(props.open);
  }, [props.open]);

  const setRating = (value) => {
    if (step === 1) {
      setPracticeRating(value);
    } else {
      setProviderRating(value);
    }
  };

  const setRespText = (value) => {
    if (step === 1) {
      setPracticeTextResp(value);
    } else {
      setProviderTextResp(value);
    }
  };

  const getButtonText = () => {
    switch (step) {
      case 1:
        return "Next";
      case 2:
        return "Submit Feedback";
      default:
        return "Close";
    }
  };

  const submitDeclinedSurvey = async () => {
    try {
      CSATService().submitCSATResponse(
        props.appId,
        props.userId,
        true,
        true,
        props.providerId,
        0,
        "",
        0,
        ""
      );
    } catch (error) {}
    closeDiag();
  };

  const submitSurvey = async () => {
    CSATService()
      .submitCSATResponse(
        props.appId,
        props.userId,
        checked,
        false,
        props.providerId,
        practiceRating,
        practiceTextResp,
        providerRating,
        providerTextResp
      )
      .then((resp) => {
        const nextStep = step + 1;
        setStep(nextStep);
      })
      .catch((err) => {
        closeDiag();
      });
  };

  useEffect(() => {
    if (step === 1) {
      if (practiceRating < 4) {
        setActivePrompt(practiceBetterText);
      } else {
        setActivePrompt(practiceEvenBetterText);
      }
    } else {
      if (providerRating < 4) {
        setActivePrompt(providerBetterText);
      } else {
        setActivePrompt(providerEvenBetterText);
      }
    }
  }, [step, providerRating, practiceRating]);

  return (
    <Dialog open={show} onClose={closeDiag}>
      <DialogContent>
        {step < 3 && (
          <div>
            <h3>{step === 1 ? practicePrompt : providerPrompt}</h3>
            <FaceSelector
              rating={step === 1 ? practiceRating : providerRating}
              setRating={setRating}
            ></FaceSelector>
            {((step === 1 && practiceRating !== null) ||
              (step === 2 && providerRating !== null)) && (
              <TextField
                multiline
                maxRows={6}
                rows={4}
                variant="outlined"
                placeholder={activePrompt}
                style={{
                  borderColor: "black",
                  borderWidth: 1,
                  height: 120,
                  borderRadius: 3,
                  padding: 7,
                  marginTop: 10,
                  fontSize: 12,
                  width: "100%",
                  fontFamily: "Poppins-Regular",
                }}
                value={step === 1 ? practiceTextResp : providerTextResp}
                onChange={(event) => {
                  setRespText(event.target.value);
                }}
              />
            )}
            {step === 2 && providerRating !== null && (
              <div style={{ marginTop: 10, marginBottom: 40 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "left",
                    alignItems: "center",
                    marginBottom: 5,
                  }}
                >
                  <p style={{ fontSize: 16 }}>
                    Include my name and email with my submission
                  </p>
                  <Switch
                    value={checked}
                    onChange={(event) => setChecked(event.target.checked)}
                  />
                </div>
                <p style={{ fontSize: 12, margin: 0 }}>
                  By leaving the above unchecked, your response will be sent
                  anonymously
                </p>
              </div>
            )}
          </div>
        )}
        {step === 3 && (
          <div>
            <h1>Thank you for your feedback!</h1>
            {props.webReviewEnabled &&
              practiceRating >= 4 &&
              providerRating >= 4 && (
                <div>
                  <p>
                    Please also take a moment to leave us a review on Google or
                    Yelp.
                  </p>
                  {!_.isEmpty(props.yelpReviewUrl) && (
                    <Button
                      color="primary"
                      variant="outlined"
                      style={{ width: "100%", marginBottom: 15 }}
                      onClick={() => {
                        window.open(props.yelpReviewUrl);
                      }}
                    >
                      Leave a YELP Review
                    </Button>
                  )}
                  {!_.isEmpty(props.googleReviewUrl) && (
                    <Button
                      color="primary"
                      variant="outlined"
                      style={{ width: "100%" }}
                      onClick={() => {
                        window.open(props.googleReviewUrl);
                      }}
                    >
                      Leave a Google Review
                    </Button>
                  )}
                </div>
              )}
            {(practiceRating <= 4 || providerRating <= 4) && (
              <p>
                We appreciate your feedback and will use it to make your future
                care better.
              </p>
            )}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        {step < 3 && (
          <Button
            color="primary"
            variant="outlined"
            onClick={() => submitDeclinedSurvey()}
          >
            Not Now
          </Button>
        )}
        <Button
          color="primary"
          variant="contained"
          disabled={
            (step === 1 && practiceRating === null) ||
            (step === 2 && providerRating === null)
          }
          onClick={() => {
            if (step === 2) {
              submitSurvey();
            } else if (step === 3) {
              closeDiag();
            } else {
              const nextStep = step + 1;
              setStep(nextStep);
            }
          }}
        >
          {getButtonText()}
        </Button>
      </DialogActions>
    </Dialog>
  );
};



// WEBPACK FOOTER //
// ./src/components/survey/CSAT.js